<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <div>
                    <app-saved-dashboard-view></app-saved-dashboard-view>
                </div>
                <div *ngFor="let link of [modify_time_campaigns_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <app-single-select
                    [option]="settingItemDateAggregation.options"
                ></app-single-select>
                <app-toggle
                    [option]="settingActiveAllCampaigns.options"
                ></app-toggle>
                <div class="revenue-settings">
                    <div>
                        <app-toggle
                            [option]="settingItemNetGross.options"
                        ></app-toggle>
                    </div>
                    <div>
                        <app-toggle
                            [option]="settingItemCurrency.options"
                        ></app-toggle>
                    </div>
                </div>
                <div class="revenue-settings">
                    <div>
                        <app-toggle
                            [option]="settingRevenueType.options"
                        ></app-toggle>
                    </div>
                </div>
                <div>
                    <div>
                        <app-multi-select
                            [option]="settingRoasSelectedDayNo.options"
                        ></app-multi-select>
                    </div>
                </div>
                <div *ngFor="let link of values(filterDashboardItemLinks)">
                    <!-- TODO Obsłużyć pozostałe typy -->
                    <app-category-filter-dashboard-item
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'CategoryFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                    </app-category-filter-dashboard-item>
                    <app-date-picker
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'DateRangeFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                        ></app-date-picker
                    >
                    <app-segment-filter
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'SegmentsFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-segment-filter>
                </div>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>
        <div class="main-container">
            <div class="grid-container">
                <app-alert-data-text
                    [dashboardItemOptions]="
                        network_warning.dashboardItemOptions
                    "
                    [dataLoaderEmitter]="network_warning.dataLoaderEmitter"
                ></app-alert-data-text>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [impressions]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [installs]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [cpi]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [cpm]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [costs]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [roas_calendar]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [new_payers]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [revenue]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [dau]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [wavg_arpdau]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [wavg_cr]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="6" *ngFor="let link of [arpu]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [running_roas]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [retention_per_day_no]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [avg_user_lifetime]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="6"
                        *ngFor="let link of [reattributions]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="6" *ngFor="let link of [new_users]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
